import { render, staticRenderFns } from "./AddSuggestionModal.vue?vue&type=template&id=40162223&"
import script from "./AddSuggestionModal.vue?vue&type=script&lang=js&"
export * from "./AddSuggestionModal.vue?vue&type=script&lang=js&"
import style0 from "./AddSuggestionModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports